import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Footer } from '@widgets/footer';
import { Button } from '@shared/widgets';
import bgImg from '@assets/images/auth/bg-02.png';

export const RecoveryOkPage = () => {
  const { navigate } = useRouteHook();

  return (
    <>
      <div className='mx-auto flex h-[702px] max-w-[1440px] overflow-hidden max-md:relative max-md:z-[1] max-md:h-auto max-md:w-full max-md:flex-col-reverse'>
        <div className='relative z-[99] w-[140px] max-md:hidden' />
        <div
          className='relative z-[99] h-[702px] w-full bg-right bg-no-repeat pl-[150px] text-left max-md:h-auto max-md:pt-0 max-md:pl-0'
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <div className='w-[320px]'>
            <h2 className='mt-[103px] font-[Prata] text-[56px] text-[#272727] max-md:mt-0 max-md:text-center max-md:text-[28px]'>
              Successful Recovery
            </h2>
            <p className='mt-2 mb-7.5 text-lg font-light text-[#4c4c4c] before:absolute before:left-0 before:mt-[15px] before:h-[1px] before:w-[125px] before:bg-[#000] max-md:text-center max-md:text-[#4c4c4c80] max-md:before:hidden'>
              Your password was updated successfully.
            </p>
            <Button className='mt-5 w-[292px] max-md:mt-8 max-md:w-full' onClick={() => navigate(RoutePaths.login.onNavigate(), { replace: true })}>
              Login
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
